import { isEmpty } from 'lodash';

const getAccountPromoResponse = (response) => {
  if (isEmpty(response?.data?.stores)) return [];

  const accountPromo = response.data.stores.map((opt) => {
    return {
      value: opt?.storeName,
      label: opt?.storeName,
      icon: opt?.ecommerce?.logo,
    };
  });

  return accountPromo;
};

export default getAccountPromoResponse;
